import React from "react";
import { Link } from "react-router-dom";
import Story from '../../assets/images/story-img.png'

const OurStory = () => (
  <div className="bodySec storySec">
    <div className="container">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
          <div className="whatWeDoTxt">
            <h2>
              <span>Our Story</span>
            </h2>
            <h4>
              <span>From Wall Street Engineering to Everyday Investors</span>
            </h4>
            <p>
              DeepTrading.ai started with a simple idea: the tools used to model markets shouldn’t be locked inside
              institutions. We built an end-to-end pipeline that learns from historical market data and publishes
              daily forecasts you can explore in seconds.
            </p>
            <p>
              Instead of a single “price target,” DeepTrading produces a structured set of horizon-based predictions
              (from tomorrow through 1 year), so you can focus on the timeframe that matches your trading style.
            </p>
            <p>
              Transparency matters: every prediction is stored, and the dashboard shows track record and accuracy
              metrics, so you can decide where the model earns your trust.
            </p>
            <Link to="/pricing-plans" className="defaultBtn">
              Get started
            </Link>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
          <div className="shadowImg">
            <img src={Story} alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OurStory;
